import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { PatientProgramApi } from '../../../apis/PatientProgramApi/PatientProgramApi.ts';
import { PatientProgram } from '../PatientProgram.ts';

export function useSetPatientProgramEventDate(patientId?: string) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<PatientProgram, AppMedError, Date>({
    mutationKey: [QueryKeys.patientProgram, patientId, 'setEventDate'],
    mutationFn: (eventDate: Date) => {
      if (!patientId)
        throw new AppMedError(
          'Patient program',
          'useSetPatientProgramEventDate requires a valid patientId',
        );
      return PatientProgramApi.setEventDate(parseInt(patientId, 10), eventDate);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.patientProgram, patientId],
      });
      notifications.show({
        color: 'teal',
        message: t('program.notifications.eventDateUpdated'),
      });
    },
    onError: (error) => {
      notifications.show({
        color: 'red',
        message: error?.message || t('program.notifications.eventDateError'),
      });
    },
  });
}
